<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <!-- Recent Order Table -->
          <div class="card card-table-border-none" id="recent-orders">
            <div class="card-header justify-content-between">
              <h2>{{ $t("menu.list.products") }}</h2>
              <div class="date-range-report ">
                <span></span>
              </div>
            </div>
            <div class="card-body pt-0 pb-5">
              <table
                class="table card-table table-responsive table-responsive-large table-striped"
                style="width:100%"
              >
                <thead>
                  <th>{{ $t("ecommerce.product.name") }}</th>
                  <th class="d-none d-md-table-cell">
                    {{ $t("attr.pictures") }}
                  </th>
                  <th class="d-none d-md-table-cell">{{ $t("attr.units") }}</th>
                  <th class="d-none d-md-table-cell">
                    {{ $t("sentence.addedDate") }}
                  </th>
                  <th class="d-none d-md-table-cell">
                    {{ $t("ecommerce.sales-type") }}
                  </th>

                  <th class="d-none d-md-table-cell">
                    {{ $t("ecommerce.product.price") }}
                  </th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="product in products" :key="product.id">
                    <td>
                      <a class="text-dark" href=""> {{ product.name }}</a>
                    </td>
                    <td class="d-none d-md-table-cell">
                      <img
                        class="thumbnail"
                        :src="
                          Array.isArray(product.pictures)
                            ? storageUrl + product.pictures[0]
                            : storageUrl + product.pictures
                        "
                      />
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{ product.quantity }} {{ $t("attr.units") }}
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{ product.updated_at | formatDate }}
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{ product.sales_type }}
                    </td>
                    <td
                      v-if="product.sales_type == 'auction'"
                      class="d-none d-md-table-cell"
                    >
                      {{ product.starting_price }}
                    </td>
                    <td v-else class="d-none d-md-table-cell">
                      {{ product.fixed_price }}
                    </td>
                    <td class="text-center">
                      <span
                        v-if="1 === product.deal_of_the_week"
                        class="mdi mdi-check color-green"
                      ></span>
                      <button
                        v-else
                        class="btn-site"
                        @click="markAsDealOFTheWeek(product.id)"
                      >
                        Marquer en tant que produit de la semaine
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  mounted() {
    let state = null;
    this.products = [];
    if (undefined !== this.$route.params.state) {
      state = this.$route.params.state;
    }
    this.getProductByState(state);
  },
  data() {
    return {
      products: [],
      success: false,
      currentPage: 1,
      totalPages: 0,
      selectedProduct: null,
      storageUrl: config.storageUrl,
      selectedPicture: "",
    };
  },
  methods: {
    showImage(picture) {
      this.selectedPicture = picture;
      this.$modal.show("picture-details");
    },
    getProductByState(state = null) {
      var self = this;
      this.$store;
      this.$axios({
        url: "admin/product/list/" + state,
        method: "GET",
      })
        .then((response) => {
          self.products = response.data;
        })
        .catch(function(err) {
          console.log(err.response.data);
        });
    },
    markAsDealOFTheWeek(productId) {
      var self = this;

      this.$axios({
        url: "admin/product/markAsDealOfTheWeek/" + productId,
        method: "POST",
      })
        .then(() => {
          self.products = this.getProductByState("inSales");
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    validate(id, reponse) {
      var self = this;

      this.$axios({
        url: "admin/product/" + reponse + "/" + id,
        method: "POST",
      })
        .then(() => {
          self.products = this.getProductByState();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    scrollToClass(className) {
      var el = this.$el.getElementsByClassName(className)[0];
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>
